import type { InitAppForPageFn } from '@wix/yoshi-flow-editor';
import { configure } from 'mobx';

configure({ isolateGlobalState: true });

export const initAppForPage: InitAppForPageFn = async () => ({});
